import { Token } from "./remote_datasource";

export class AppConfig{
    static appId: string = 'd707bd57-a2d4-4eac-860e-29df15daf231';
    // Versões vigentes dos documentos legais exibidos no aceite de termos
    static readonly versaoTermos: string = '1.0.0';
    static readonly versaoPrivacidade: string = '1.0.0';
    static municipioId: string;
    static ouvidoriaId: string;
    static agenteId: string;
    static municipioLong: number;
    static tokenAcesso?: string;
    static refreshToken?: string;
    static dataExpiracao?: string;
    static chaveRecuperacao?: string;
    static segredoRecuperacao?: string;
    static tokenNotificacao?: string;
    static token?: Token;
    static recuperacaoId?: string;
    static endereco?: string;

    // Inicializa o AppConfig com valores do localStorage
    static initialize() {
        if (typeof localStorage !== 'undefined') {
            this.municipioId = localStorage.getItem('municipioId') as string || '';
            this.ouvidoriaId = localStorage.getItem('ouvidoriaId') as string || '';
            this.agenteId = localStorage.getItem('agenteId') as string || '';
        }
    }

    // Identificação das telas para reportar problemas
    static readonly SCREEN_IDS = {
        DASHBOARD: 'DASHBOARD',
        SOLICITACOES: 'SOLICITACOES',
        SOLICITACAO_DETALHES: 'SOLICITACAO_DETALHES',
        AGENTES: 'AGENTES',
        AGENTE_DETALHES: 'AGENTE_DETALHES',
        OUVIDORIA: 'OUVIDORIA',
        OUVIDORIAS_SUPERVISIONADAS: 'OUVIDORIAS_SUPERVISIONADAS',
        OUVIDORIA_SUPERVISIONADA_DETALHES: 'OUVIDORIA_SUPERVISIONADA_DETALHES',
        SUPERVISORA: 'SUPERVISORA',
        TOPICOS: 'TOPICOS',
        RELATORIOS: 'RELATORIOS',
        CONFIGURACOES: 'CONFIGURACOES',
        CONFIGURAR_CATEGORIAS: 'CONFIGURAR_CATEGORIAS',
        PERFIL: 'PERFIL',
        CRIAR_OUVIDORIA: 'CRIAR_OUVIDORIA',
        EDITAR_OUVIDORIA: 'EDITAR_OUVIDORIA',
        CADASTRO_AGENTE: 'CADASTRO_AGENTE',
        CONVITE_AGENTE: 'CONVITE_AGENTE',
        NOTIFICACAO_DETALHES: 'NOTIFICACAO_DETALHES',
        LOGIN: 'LOGIN',
        ESQUECEU_SENHA: 'ESQUECEU_SENHA',
        AUTENTICACAO_DOIS_FATORES: 'AUTENTICACAO_DOIS_FATORES',
        REDEFINIR_SENHA: 'REDEFINIR_SENHA',
        CONVITE_USADO: 'CONVITE_USADO',
        REPORTAR_PROBLEMA: 'REPORTAR_PROBLEMA',
        NOT_FOUND: 'NOT_FOUND',
    } as const;

    static getScreenId(path: string): string {
        const pathMap: Record<string, keyof typeof AppConfig.SCREEN_IDS> = {
            '/': 'DASHBOARD',
            '/solicitacoes': 'SOLICITACOES',
            '/solicitacoes/:id': 'SOLICITACAO_DETALHES',
            '/agentes': 'AGENTES',
            '/agentes/:id': 'AGENTE_DETALHES',
            '/ouvidoria': 'OUVIDORIA',
            '/ouvidorias-supervisionadas': 'OUVIDORIAS_SUPERVISIONADAS',
            '/ouvidorias-supervisionadas/:id': 'OUVIDORIA_SUPERVISIONADA_DETALHES',
            '/supervisora': 'SUPERVISORA',
            '/topicos': 'TOPICOS',
            '/relatorios': 'RELATORIOS',
            '/configuracoes': 'CONFIGURACOES',
            '/configurar-categorias': 'CONFIGURAR_CATEGORIAS',
            '/perfil': 'PERFIL',
            '/criar-ouvidoria': 'CRIAR_OUVIDORIA',
            '/editar-ouvidoria': 'EDITAR_OUVIDORIA',
            '/cadastro-agente': 'CADASTRO_AGENTE',
            '/convite-agente': 'CONVITE_AGENTE',
            '/notificacoes/:id': 'NOTIFICACAO_DETALHES',
            '/login': 'LOGIN',
            '/esqueceu-senha': 'ESQUECEU_SENHA',
            '/autenticacao-dois-fatores': 'AUTENTICACAO_DOIS_FATORES',
            '/redefinir-senha': 'REDEFINIR_SENHA',
            '/convite-usado': 'CONVITE_USADO',
            '/reportar-problema': 'REPORTAR_PROBLEMA',
            '/not-found': 'NOT_FOUND',
        };

        // Para rotas dinâmicas, extrai o padrão base
        const normalizedPath = path.replace(/\/\d+/g, '/:id');
        const screenKey = pathMap[normalizedPath];

        if (screenKey && this.SCREEN_IDS[screenKey]) {
            return this.SCREEN_IDS[screenKey];
        }

        // Fallback para telas não mapeadas
        const pathParts = path.split('/').filter(Boolean);
        const screenName = pathParts.length > 0 
            ? pathParts.join('_').toUpperCase() 
            : 'UNKNOWN';
        
        return screenName;
    }
}
